import {
  Button,
  Container,
  CssBaseline,
  Grid,
  makeStyles,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { getSessionData } from "../../base/helper/baseHelper";
import SelectableSearch from "../../base/views/SelectableSearch";
import { useForm } from "../../base/views/useForm";
import {
  GetCityDropDownData,
  GetCountryDropDownData,
  GetStateDropDownData,
  GetZipDetails,
} from "../../SignUp/helper/signUpHelper";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "10px",
    marginTop: "1%",
    justifyContent: "center",
    alignItems: "center",
  },
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {
    alignItems: "center",
  },
  column: {
    flexBasis: "50%",
  },
  helper: {
    paddingLeft: theme.spacing(2),
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(1),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  margin: {
    margin: theme.spacing(1),
  },
  formControl: {
    margin: 0,
    fullWidth: true,
    display: "flex",
    wrap: "nowrap",
  },
}));

const EditPharmacy = (props) => {
  const classes = useStyles();
  const [countryData, setCountryData] = useState({
    load: false,
    values: [],
  });
  const [stateData, setStateData] = useState({
    load: false,
    values: [],
  });
  const [cityData, setCityData] = useState({
    load: false,
    values: [],
  });
  const { recordForEdit, addOrEdit, editStore } = props;
  const [userId, setUserId] = useState("");

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
  }, []);
  useEffect(() => {
    if (recordForEdit !== null) {
      const country = {
        id: recordForEdit.country_id,
        optionname: recordForEdit.country,
      };
      const state = {
        id: recordForEdit.state_id,
        optionname: recordForEdit.state,
      };
      const city = {
        id: recordForEdit.city_id,
        optionname: recordForEdit.city,
      };
      setValues({
        ...recordForEdit,
        country,
        state,
        city,
      });
    }
    // eslint-disable-next-line
  }, [recordForEdit]);

  const validate = (store) => {
    const error = {};
    if (!store.storename) error.storename = "Pharmacy Name is required";
    if (!store.store_alias) error.storealias = "Pharmacy Alias is required";
    if (!store.storetaxnumber)
      error.storetaxnumber = "Pharmacy Tax Number is required";
    if (!store.street1) error.street1 = "Street1 is required";
    if (!store.country.optionname) error.country = "Country is required";
    if (!store.city.optionname) error.city = "City is required";
    if (!store.state.optionname) error.state = "State is required";
    if (!store.zipcode) error.zipcode = "Zip is required";

    setErrors(error);
    return Object.values(error).every((e) => e === "");
  };
  const {
    errors,
    values,
    setValues,
    handleInputChange,
    resetForm,
    setErrors,
  } = useForm({});

  const updateZipField = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    var params = { zipcode: e.target.value };

    GetZipDetails(params).then((response) => {
      if (response && response.length) {
        var countryResponse = {
          id: response[0].country_id,
          optionname: response[0].country_name,
        };
        var stateResponse = {
          id: response[0].state_id,
          optionname: response[0].state_name,
        };
        var cityResponse = {
          id: response[0].city_id,
          optionname: response[0].city_name,
        };
        setValues({
          ...values,
          country: {
            id: countryResponse.id,
            optionname: countryResponse.optionname,
          },
          state: {
            id: stateResponse.id,
            optionname: stateResponse.optionname,
          },
          city: {
            id: cityResponse.id,
            optionname: cityResponse.optionname,
          },
          zipcode: params.zipcode,
        });
      } else {
        setValues({
          ...values,
          country: {},
          state: {},
          city: {},
          zipcode: params.zipcode,
        });
      }
    });
  };
  const loadingCountry = () => {
    setCountryData({ ...countryData, load: true });
    GetCountryDropDownData()
      .then((response) => {
        setCountryData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingState = (countryId = 0) => {
    setStateData({ ...stateData, load: true });
    var params = { country_id: countryId };
    GetStateDropDownData(params)
      .then((response) => {
        setStateData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const loadingCity = (stateId = 0) => {
    setCityData({ ...cityData, load: true });
    var params = { state_id: stateId };
    GetCityDropDownData(params)
      .then((response) => {
        setCityData({ load: false, values: response });
      })
      .catch((err) => {});
  };

  const handleCountryChange = (event, value) => {
    if (value && value.id) {
      setValues({
        ...values,
        country: { id: value.id, optionname: value.optionname },
        state: {},
        city: {},
        zipcode: "",
      });
    }
    setStateData({ values: [], ...stateData });
    setCityData({ values: [], ...cityData });
  };
  const handleStateChange = (event, value) => {
    setCityData({ values: [], ...cityData });
    if (value && value.id) {
      const state = {
        id: value.id,
        optionname: value.optionname,
      };
      setValues({ ...values, state, city: {}, zipcode: "" });
    }
  };

  const handleCityChange = (event, value) => {
    if (value && value.id) {
      const city = { id: value.id, optionname: value.optionname };
      setValues({ ...values, city, zipcode: "" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate(values)) {
      editStore({ userId, ...values });
      addOrEdit(resetForm);
    }
  };

  return (
    <div className={classes.paper}>
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <div className={classes.column}>
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id={"storeName_" + values.id}
                  name="storename"
                  value={values.storename}
                  autoComplete="sname"
                  variant="outlined"
                  required
                  fullWidth
                  label="Pharmacy Name"
                  autoFocus
                  onChange={handleInputChange}
                  {...(errors &&
                    errors.storeName && {
                      error: true,
                      helperText: errors.storename,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"storeAlias" + values.id}
                  name="store_alias"
                  autoComplete="storeAlias"
                  value={values.store_alias}
                  variant="outlined"
                  required
                  fullWidth
                  label="Pharmacy Alias"
                  onChange={handleInputChange}
                  {...(errors &&
                    errors.storealias && {
                      error: true,
                      helperText: errors.storealias,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"street1_" + values.id}
                  name="street1"
                  autoComplete="street1"
                  value={values.street1}
                  variant="outlined"
                  required
                  fullWidth
                  label="Street1"
                  onChange={handleInputChange}
                  {...(errors &&
                    errors.street1 && {
                      error: true,
                      helperText: errors.street1,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"street2_" + values.id}
                  name="street2"
                  autoComplete="street2"
                  value={values.street2}
                  variant="outlined"
                  fullWidth
                  label="Street2"
                  onChange={handleInputChange}
                  {...(errors &&
                    errors.street2 && {
                      error: true,
                      helperText: errors.street2,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"zip" + values.id}
                  name="zipcode"
                  autoComplete="zip"
                  value={values.zipcode}
                  variant="outlined"
                  required
                  fullWidth
                  label="Zip"
                  onChange={updateZipField}
                  {...(errors &&
                    errors.zipcode && {
                      error: true,
                      helperText: errors.zipcode,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <SelectableSearch
                  value={{ ...values.city }}
                  data={cityData}
                  name="city"
                  label="City"
                  id={"city"}
                  loading={() => {
                    loadingCity(values.state.id);
                  }}
                  onChangeEvent={handleCityChange}
                  {...(errors &&
                    errors.city && {
                      error: true,
                      helperText: errors.city,
                    })}
                ></SelectableSearch>
              </Grid>
              <Grid item xs={6}>
                <SelectableSearch
                  value={{ ...values.state }}
                  data={stateData}
                  name="state"
                  label="State"
                  id={"state"}
                  loading={() => {
                    loadingState(values.country.id);
                  }}
                  onChangeEvent={handleStateChange}
                  {...(errors &&
                    errors.state && {
                      error: true,
                      helperText: errors.state,
                    })}
                ></SelectableSearch>
              </Grid>
              <Grid item xs={6}>
                <SelectableSearch
                  value={{ ...values.country }}
                  data={countryData}
                  name="country"
                  label="Country"
                  id={"country"}
                  loading={loadingCountry}
                  onChangeEvent={handleCountryChange}
                  {...(errors &&
                    errors.country && {
                      error: true,
                      helperText: errors.country,
                    })}
                ></SelectableSearch>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"storelandline" + values.id}
                  name="storelandline"
                  autoComplete="storelandline"
                  value={values.storelandline}
                  variant="outlined"
                  fullWidth
                  label="Pharmacy Landline"
                  onChange={handleInputChange}
                  {...(errors &&
                    errors.storelandline && {
                      error: true,
                      helperText: errors.storelandline,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id={"storetaxnumber" + values.id}
                  name="storetaxnumber"
                  autoComplete="storetaxnumber"
                  value={values.storetaxnumber}
                  variant="outlined"
                  fullWidth
                  label="Pharmacy TaxNumber"
                  onChange={handleInputChange}
                  {...(errors &&
                    errors.storetaxnumber && {
                      error: true,
                      helperText: errors.storetaxnumber,
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  name="plan"
                  id="panselectoutlined"
                  variant="outlined"
                  disabled={true}
                  label="Plan"
                  fullWidth
                  value={values.planname}
                ></TextField>
              </Grid>
            </Grid>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                style={{ width: "20vw", backgroundColor: "rgb(22, 177, 255)" }}
                type="submit"
                onClick={handleSubmit}
              >
                Save
              </Button>
            </div>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default EditPharmacy;
